import React from 'react';
import {
  Headings,
  Paragraph,
  Image,
  Link,
  ExternalLinkIcon,
  GlobalWarning,
} from '@sentara-health/optimahealth_web';
import {
  errorhandler,
  navigateToExternalUrl,
  ANALYTICS_MESSAGES,
  generateCustomAdobeContentTitle,
  useAnalytics,
} from 'common';
import { useTranslation } from 'react-i18next';
import { useModBaseSSOUrl } from '@sentara-health/sentara-api-hooks-core';

interface Program {
  img: string;
  title: string;
  description: string;
  link: string | undefined;
  linkText: string;
}

interface WellnessProgramItemProps {
  program: Program;
  index: number;
}

const WellnessProgramItem: React.FC<WellnessProgramItemProps> = ({
  program,
  index,
}) => {
  const { t } = useTranslation();
  const { fetchModBaseSSOUrl } = useModBaseSSOUrl();
  const { trackContentListing } = useAnalytics();
    const getAPIUrl = async () => {
        const res = await fetchModBaseSSOUrl('guestapi/v1/guest/webmdsso');
        if (res?.data?.result?.ssoUrl) {
            navigateToExternalUrl(res?.data?.result?.ssoUrl);
        } else if (res?.data?.exceptions?.errorMessage) {
            errorhandler(res.data.exceptions.errorMessage);
        }

    };

    const handleOnItemClick = (index:number) => {
      const contentTitle = generateCustomAdobeContentTitle(
        program.title,
        ANALYTICS_MESSAGES.WELLNESS_PROGRAM_ITEM_CLICK_SUFFIX
      );
      trackContentListing(String(index), contentTitle, index);
      if (index=== 1) {
          getAPIUrl();
      } else {
          navigateToExternalUrl(program.link)
      }
  }
  
  return (
    <div className="row">
      <div className="col-lg-4 col-md-4 col-sm-12 col-12 pb-2 p-0">

        <Image path={program.img} alt={program.title} className="img-fluid" />
      </div>
      <div className="col-lg-7 col-md-7 col-sm-12 col-12 pt-0">
        <Headings level={2} text={program.title} variant="semibold" />
        <Paragraph
          text={program.description}
          variant="regular"
          data-testid="programDescription"
        />
        <div className="mt-3 d-flex align-items-center gap-2">
          <div>
            <Link
              data-testid="program-link"
              onClick={()=>handleOnItemClick(index)}
            >
              {program.linkText}
            </Link>
          </div>
          <div>
            <ExternalLinkIcon />
          </div>
        </div>
        <div className="pt-4">
          {index === 1 && (
            <GlobalWarning
              variant="warning"
              dataTestId="alertShowWarningMessage"
            >
              {t(
                'wellnessPrograms.wellnessTools.WarningMessage'
              )}
            </GlobalWarning>
          )}
        </div>
      </div>
    </div>
  );
};
export default WellnessProgramItem;
